import React , { useState,useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Box, Typography, Grid, Button, MenuItem, TextField, Select, Card, CardContent, TableContainer, Table, TableHead, TableBody, Snackbar, Alert, Modal, Checkbox, IconButton } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import legolasApi from '../../api/legolas'
import { isArray, isEmpty } from 'lodash'
import globalConfig from '../../utils/globalConfig'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import generateToken from '../../utils/generateToken'
import { useParams } from 'react-router-dom';

const ReturnForm = (props) => {
  console.log("proprssss",props.item)
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [isGiftChecked, setIsGiftChecked] = React.useState(false);
  const memoizedArray = React.useMemo(() => getDropdownVals(props.item.qty_purchased))
  const genBarcode = []
  if(props.isApproved) {
    props.item.barcode_applied = true;
  }
  
  const approvedArray = [null].concat(memoizedArray)
  if (isArray(props.item.barcode)) {
    genBarcode = props.item.barcode
  } else {
    genBarcode.push(props.item.barcode)
  }
  const handleCheckboxChange = (event) => {
    setIsGiftChecked(event.target.checked);
    if (event.target.checked) {
      props.updateItemsPayload(props.item.item_id, "reason_id", "1");
      props.updateItemsPayload(props.item.item_id, "condition_id", "1");
      props.updateItemsPayload(props.item.item_id, "resolution_id", "2");
      props.updateItemsPayload(props.item.item_id, "qty_requested", props.item.quantity);
      props.updateItemsPayload(props.item.item_id, "qty_authorized", "2");
      props.updateItemsPayload(props.item.item_id, "qty_received", "2");
      props.updateItemsPayload(props.item.item_id, "qty_approved", "2");
      props.updateItemsPayload(props.item.item_id, "barcode", "2");

    } 
  };

  
  // const itemFinalPrice = parseFloat(props.item.price_incl_tax) - parseFloat(props.item.discount);
  // console.log("itemFinalPrice: ", props.item);
  return (
    <StyledTableRow>
      {/* <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        Image
      </StyledTableCell> */}
      <StyledTableCell align='left' sx={{ minWidth: '200px' }}>
        {props.item.product_name ? JSON.parse(props.item.product_name)["en-SA"] : 'Product Name'} <br></br> SKU: {props.item.product_SKU}<br></br> Oracle Id : {props.item.product_oracle_id}
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        {props.item.price_incl_tax && parseFloat(props.item.price_incl_tax) >= 1 ? `SAR ${props.item.price_incl_tax}` : '0'} 
     </StyledTableCell>
     {props.item.is_gift_product === 0  || props.item.is_gift_product === null? 
      (
        <>
      <StyledTableCell>
        <Select 
          label='Select Return Reason' 
          value={props.item.reason_id}
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "reason_id", e.target.value.toString())}
        >
          {props.returnOptions.returnReason.map(item => {
            return (
              <MenuItem value={item.id}>{item.title}</MenuItem>
            )
          })}
        </Select>
      </StyledTableCell>
      <StyledTableCell>
        <Select 
          label='Select Return Condition' 
          value={props.item.condition_id}
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "condition_id", e.target.value.toString())}
        >
          {props.returnOptions.returnCondition.map(item => {
            return (
              <MenuItem value={item.id}>{item.title}</MenuItem>
            )
          })}
        </Select>
      </StyledTableCell>
      <StyledTableCell>
        <Select 
          label='Select Return Resolution' 
          value={props.item.resolution_id}
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', '&.Mui-disabled' : { opacity: 0.5 } }}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "resolution_id", e.target.value.toString())}
        >
          {props.returnOptions.returnResolution.map(item => {  
            return (
              <MenuItem value={item.id}>{item.title}</MenuItem>
            )
          })}
        </Select>
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        <TextField 
          label="Purchased Qty" 
          variant="outlined" 
          value={props.item.qty_purchased}
          sx={{ pointerEvents: 'none', backgroundColor: '#fff' }}
        />
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        <Select 
          label='Return Qty' 
          value={props.item.qty_requested}
          placeholder="Select Return Qty"
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', '&.Mui-disabled' : { opacity: 0.5 } }}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "qty_requested", e.target.value)}
          disabled={props.item.qty_purchased == null}
        >
          {
            memoizedArray.map(item => {
              return (
                <MenuItem value={item}>{item}</MenuItem>
              )
            })
          }
        </Select>
        {/* {
          props.item.errors.qty_requested &&
          <Typography sx={{ color: 'red', fontSize: '14px', fontWeight: 700 }}>Please select a return qty</Typography>
        } */}
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        <Select 
          label='Authorized Qty' 
          value={props.item.qty_authorized}
          placeholder="Select Authorized Qty"
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', '&.Mui-disabled' : { opacity: 0.5 }}}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "qty_authorized", e.target.value)}
          // disabled={props.item.qty_requested == null}
          disabled={storedUser.id == 38 ? false : true } 
        >
          {
            memoizedArray.map(item => {
              return (
                <MenuItem value={item}>{item}</MenuItem>
              )
            })
          }
        </Select>
        {/* {
          props.item.errors.qty_authorized && !props.item.errors.qty_requested &&
          <Typography sx={{ color: 'red', fontSize: '14px', fontWeight: 700 }}>Please select an authorized qty</Typography>
        } */}
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        <Select 
          label='Received Qty' 
          value={props.item.qty_received}
          placeholder="Select Received Qty"
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', '&.Mui-disabled' : { opacity: 0.5 }}}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "qty_received", e.target.value)}
          // disabled={props.item.qty_authorized == null}
          disabled={storedUser.id == 38 ? false : true }
        >
          {
            memoizedArray.map(item => {
              return (
                <MenuItem value={item}>{item}</MenuItem>
              )
            })
          }
        </Select>
        {/* {
          props.item.errors.qty_received && !props.item.errors.qty_authorized &&
          <Typography sx={{ color: 'red', fontSize: '14px', fontWeight: 700 }}>Please select a received qty</Typography>
        } */}
      </StyledTableCell>
      <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
        <Select 
          label='Approved Qty' 
          value={props.item.qty_approved}
          placeholder="Select Approved Qty"
          sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', '&.Mui-disabled' : { opacity: 0.5 }}}
          onChange={(e) => props.updateItemsPayload(props.item.product_id, "qty_approved", e.target.value)}
          // disabled={props.item.qty_received == null}
          disabled={storedUser.id == 38 ? false : true }
        >
          {
            approvedArray.map(item => {
              if (item == null) {
                return (
                  <MenuItem value={null}>No Selection</MenuItem>
                )
              } else {
                return (
                  <MenuItem value={item}>{item}</MenuItem>
                )
              }
            })
          }
        </Select>
        {/* {
          props.item.errors.qty_approved && !props.item.errors.qty_received &&
          <Typography sx={{ color: 'red', fontSize: '14px', fontWeight: 700 }}>Please select a approved qty</Typography>
        } */}
      </StyledTableCell>
      <StyledTableCell>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'row', 
          backgroundColor: '#87CEEB',
          padding: '10px 20px' 
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', margin: '0px 10px' }}>
            <Typography variant='h6' sx={{ marginBottom: '20px' }}>Barcode</Typography>
            <Select 
              sx={{ minWidth: '200px', border: '1px solid #000', height: '30px', margin: 0, padding: 0, borderRadius: 0 }}
              onChange={(e) => props.updateItemsPayload(props.item.product_id, "barcode", e.target.value)}
            >
              {
                genBarcode.map(item => {
                  return (
                    <MenuItem value={item}>{item}</MenuItem>
                  )
                })
              }
            </Select>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', margin: '0px 10px'  }}>
            <Typography variant='h6' sx={{ marginBottom: '20px' }}>Qty</Typography>
            <Select 
              sx={{ minWidth: '75px', border: '1px solid #000', height: '30px', margin: 0, padding: 0, borderRadius: 0 }}
              onChange={(e) => props.updateItemsPayload(props.item.product_id, "barcode_qty", e.target.value)}
            >
              {
                memoizedArray.map(item => {
                  return (
                    <MenuItem value={item}>{item}</MenuItem>
                  )
                })
            }
            </Select>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', margin: '0px 10px'  }}>
            <Typography variant='h6' sx={{ marginBottom: '20px' }}>Action</Typography>
            <Button 
              sx={{ height: '30px', margin: 0, padding: '10px 20px', backgroundColor: '#2b3f7a !important', color: '#fff !important', borderRadius: 0 }}
              onClick={() => props.setBarcodeInfo(props.item.product_id)}
            >
              Add
            </Button>
          </Box>
        </Box>
        {
          props.item.barcode_applied &&
          <Box sx={{ backgroundColor: '#87CEEB', padding: '20px 30px 10px' }}>
            <Typography>Barcode <span sx={{ fontWeight: 'bold' }}>{props.item.barcode}</span> applied for approved Qty <span sx={{ fontWeight: 'bold' }}>{props.item.qty_approved}</span></Typography>
          </Box>
        }
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant='h6' sx={{ marginBottom: '20px', fontSize: '14px' }}>{globalConfig.rmaStatus[props.item.status].text}</Typography>
      </StyledTableCell>
            </>
      )
            : (
              <>
              <StyledTableCell colSpan={7} align="center">
                This is a gift item 
              </StyledTableCell>
               <StyledTableCell colSpan={2} align="center">
              {/* <Checkbox  checked={isGiftChecked} onChange={handleCheckboxChange}  sx={{ transform: 'scale(1.5)' }}/> */}
              <Checkbox disabled={true} checked={true}  sx={{ transform: 'scale(1.5)' }}/>
              <span>
                {props.item.qty_requested + " Quantity"}
              </span>
             </StyledTableCell>
             </>
            )
      }
    </StyledTableRow>
  )
}

function getDropdownVals(qty) {
  let output = [0]
  for (let i = 1; i <= qty; i++) {
    output.push(i)
  }
  return output
}

function EditReturn() {
  
  const { id } = useParams();
  //const { state : { data } } = useLocation()
  const location = useLocation();
  const data = location?.state?.data || null;
  const [returnableData, setReturnableData] = React.useState([])
  const [itemsPayload, setItemsPayload] = React.useState([])
  const navigate = useNavigate()
  const [updateData, setUpdateData] = React.useState({})
  const [adminUsers, setAdminUsers] = React.useState([])
  const [returnOptions, setReturnOptions] = React.useState([])
  const [fullItems, setFullItems] = React.useState([])
  const [orderDetails, setOrderDetails] = React.useState({})
  console.log("daklsdjaslkdjaskldjaslkdjaskdjaskdjsakdj   order detail ", orderDetails.order_id);
  
  const [cmemoPresent, setCmemoPresent] = React.useState(false)
  const [defaultCarrier, setDefaultCarrier] = React.useState(null)
  const [approveReject, setApproveReject] = React.useState('')
  const [openWarning, setOpenWarning] = React.useState(false)
  const [openSuccess, setOpenSuccess] = React.useState(false)
  const itemsTableRef = React.useRef(null)
  const [alertSuccess, setAlertSuccess] = React.useState('')
  const [alertWarning, setAlertWarning] = React.useState('')
  const [isCancelled, setIsCancelled] = React.useState(false)
  const [isApproved, setIsApproved] = React.useState(false)
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [purchasedFrom,setPurchaseFrom] = React.useState('');
  const [totalPriceToReturn, settotalPriceToReturn] = React.useState(0)
  console.log(totalPriceToReturn);
  const [returnImages, setReturnImages] = useState([]);
  const [imagesParsed, setImagesParsed] = React.useState(false);
    const [activeImage, setActiveImage] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const media_cdn = process.env.REACT_APP_MEDIA_CDN_PATH;

  const [open, setOpen] = React.useState(false);
  const scrollToTable = () => itemsTableRef.current.scrollIntoView()

  React.useEffect(() => {
    console.log('updated items payload', itemsPayload)
  }, [itemsPayload])

  React.useEffect(() => {
    if (orderDetails?.image_paths && !imagesParsed) {
      try {
        const parsed = JSON.parse(orderDetails.image_paths);

        if (Array.isArray(parsed)) {
          const fullPaths = parsed
            .filter(Boolean)
            .map((path) =>
              path.startsWith('http') ? path : `${media_cdn}/${path}`
            );
          setReturnImages(fullPaths);
        }
      } catch (e) {
        console.error("Failed to parse image_paths:", e);
        setReturnImages([]);
      } finally {
        setImagesParsed(true); 
      }
    }
  }, [orderDetails?.image_paths, imagesParsed]);

  React.useEffect(() => {
    // console.log('location data')
    // console.log(data)
    const url = `${legolasApi.url}/admin/rma/returnitem/details`
    axios.post(url, { "order_id" : id, "source": "admin" }).then(res => {
      const resData = res.data.data
      // console.log('return resData', resData)
      //setAdminUsers(res.data.data.users)
      const returnableItems = resData.rmaOrdersDetails
      const orderDetails = resData.rmaOrdersDetails[0]
      const totalpricecart = resData.totalPrice
      settotalPriceToReturn(totalpricecart)
      // console.log('orderDetails', orderDetails)
      const newUpdateData = {
        return_type : orderDetails.return_type,
        status: orderDetails.status,
        is_closed : orderDetails.is_closed,
        manager_id : (orderDetails.manager_id == null) ? 104 : orderDetails.manager_id
      }
      setUpdateData(newUpdateData)
      setCarrierInfo(orderDetails.shipping_method)
      setFullItems(returnableItems)
      setOrderDetails(orderDetails)
      setPurchaseFrom(orderDetails.channel_id)
      // console.log('orderDetails', orderDetails)
      if (orderDetails.status == 'rejected') {
        setIsCancelled(true);
      } else if (orderDetails.status == 'approved') {
        setIsApproved(true);
      }

      if (isArray(returnableItems) && returnableItems.length > 0) {
        let itemsGroup = []
        returnableItems.forEach((item, idx) => {
          let returnGroup = {
            "id" : item.order_item_id,
            "reason_id" : item.reason_id,
            "condition_id" : item.condition_id,
            "resolution_id" : item.resolution_id,
            "qty_purchased" : item.qty_purchased,
            "qty_requested" : item.qty_requested,
            "qty_authorized" : item.qty_authorized,
            "qty_received" : item.qty_received,
            "qty_approved" : item.qty_approved,
            "increment_id" : item.increment_id,
            "product_name" : item.product_name,
            "price_incl_tax" : (item.price_incl_tax - parseFloat(item.discount)),
            "status" : item.status,
            "product_id" : item.product_id,
            "order_item_id" : item.order_item_id,
            "product_SKU" : item.sku,
            "product_oracle_id":item.oracle_id,
            "barcode" : item.barcode,
            "barcode_applied" : false,
            "barcode_qty" : item.barcode_qty,
            "in_approved_state": false,
            "errors" : {
              "qty_requested" : false,
              "qty_authorized" : false,
              "qty_received" : false,
              "qty_approved" : false
            } ,"is_gift_product": item.is_gift_product
          }
          //itemsGroup[item.order_item_id] = returnGroup
          itemsGroup.push(returnGroup)
        })
        // console.log('itemsGroup', itemsGroup)
        setItemsPayload(itemsGroup)
      }
      setReturnOptions(resData.returnOptions)


    })
    axios.get(`${legolasApi.url}/admin/rma/manager/list`).then(res => {
      const usersData = res.data.data.rows
      console.log("Admin Users:", usersData);
      setAdminUsers(usersData)
      // const foundManager = usersData.find(user => user.user_id == '37')
      // setManagerId(foundManager.user_id)

    })
  }, [])

  const ImagePreview = ({ srcList = [] }) => {

    const handleOpen = (index) => {
    setActiveIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? srcList.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === srcList.length - 1 ? 0 : prev + 1));
  };

  const currentImage = srcList[activeIndex];

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        handlePrev();
      } else if (e.key === 'ArrowRight') {
        handleNext();
      } else if (e.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  return (
    <>
      {/* Thumbnails */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {srcList.map((src, index) => (
          <Box
            key={index}
            onClick={() => handleOpen(index)}
            sx={{
              cursor: 'pointer',
              border: '1px solid #ccc',
              borderRadius: '8px',
              overflow: 'hidden',
              width: 150,
              height: 150,
            }}
          >
            <img
              src={src}
              alt={`Preview-${index}`}
              onError={(e) => {
                if (!e.target.dataset.fallback) {
                  e.target.src = '/no-image.png';
                  e.target.dataset.fallback = 'true';
                }
              }}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
        ))}
      </Box>

      {/* Modal View */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.85)',
            p: 2,
          }}
        >
          {/* Close (×) */}
          <Box
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 20,
              right: 30,
              color: '#fff',
              fontSize: '28px',
              cursor: 'pointer',
              zIndex: 10,
            }}
          >
            ×
          </Box>

          {/* Prev (Left Triangle) */}
          {srcList.length > 1 && (
            <Box
              onClick={handlePrev}
              sx={{
                position: 'absolute',
                left: 20,
                width: 0,
                height: 0,
                borderTop: '10px solid transparent',
                borderBottom: '10px solid transparent',
                borderRight: '10px solid white',
                cursor: 'pointer',
                zIndex: 10,
              }}
            />
          )}

          {/* Image */}
          <img
            src={currentImage}
            alt="Zoomed"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: '10px',
              boxShadow: '0 0 10px rgba(0,0,0,0.5)',
            }}
            onError={(e) => {
              if (!e.target.dataset.fallback) {
                e.target.src = '/no-image.png';
                e.target.dataset.fallback = 'true';
              }
            }}
          />

          {/* Next (Right Triangle) */}
          {srcList.length > 1 && (
            <Box
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: 20,
                width: 0,
                height: 0,
                borderTop: '10px solid transparent',
                borderBottom: '10px solid transparent',
                borderLeft: '10px solid white',
                cursor: 'pointer',
                zIndex: 10,
              }}
            />
          )}
        </Box>
      </Modal>
    </>
    );
  };

  const darkBox = {
    width: '100%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '100%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#fff',
    padding: '10px'
  }

  const purchasedFromDefault = 'Shababuna Website'
  const extraHeaders = [
    { label: 'Authorized Qty', hasTooltip: false },
    { label: 'Received Qty', hasTooltip: false },
    { label: 'Approved Qty', hasTooltip: false },
    { label: 'Barcodes - Qty Mapping', hasTooltip: false },
    { label: 'Status', hasTooltip: false }
  ]

  //top menu click handlers
  const backClickHandler = () => {
    navigate('/returns')
  }

  const handleOpenCancelConfirmation = () => {
    setOpenCancelConfirmation(true);
  };
  const handleCloseCancelConfirmation = () => {
    setOpenCancelConfirmation(false);
  };


  const updateReturnType = (type) => {
    const currentUpdateData = {...updateData}
    currentUpdateData['return_type'] = type
    setUpdateData(currentUpdateData)
  }

  const updateReturManager = (manager_id) => {
    const currentUpdateData = {...updateData}
    currentUpdateData['manager_id'] = manager_id
    setUpdateData(currentUpdateData)
  }

  const updateItemsPayload = (inc, type, val) => {
    console.log("inc", inc, "type", type, "value", val);
    let currentPayload = [...itemsPayload]
    const foundItem = currentPayload.find(item => item.product_id == inc)
    const index = currentPayload.indexOf(foundItem)
    currentPayload[index][type] = val
    if (type == "qty_requested" || type == "qty_authorized" || type == "qty_received" || type == "qty_approved") {
      currentPayload[index]["errors"][type] = false
      currentPayload[index]["in_approved_state"] = false
    }
    if (type == "qty_approved" && val != null) {
      currentPayload[index]["in_approved_state"] = true
    }
    setItemsPayload(currentPayload)
  }

  const setCarrierInfo = (ship) => {
    switch (ship) {
      case 'esnad':
        setDefaultCarrier('esnad')
        break

      case 'Shababuna':
        setDefaultCarrier('Shababuna')
        break

      case 'webkularamex':
        setDefaultCarrier('webkularamex')
        break

      default:
        setDefaultCarrier('Shababuna')
        break
    }
  }

  const setBarcodeInfo = (barcode_id) => {
    let currentPayload = [...itemsPayload]
    const foundItem = currentPayload.find(item => item.product_id == barcode_id)
    const index = currentPayload.indexOf(foundItem)
    currentPayload[index]['barcode_applied'] = true;
    setItemsPayload(currentPayload)
  }

  const verifyBeforeApproving = async (itemsArray) => {
    let allow = false
    await axios.post(`${legolasApi.url}/admin/check/creditmemo`, { orderId : orderDetails.order_id }).then(res => {
      const successData = res.data
      if (successData.success && successData.hasCreditMemo) {
        allow = true
      } else {
        const appReject = 'Please generate credit memo before approving return'
        setApproveReject(appReject)
        handleAlertWarning(appReject)
      }
    })
    if (typeof defaultCarrier != "string") {
      allow = false
      const appReject = 'Carrier details not set'
      setApproveReject(appReject)
      handleAlertWarning(appReject)
    }
    if (allow) {
      for (let i = 0; i < itemsArray.length; i++) {
        const item = itemsArray[i].data
        if (item.in_approved_state) {
          if (item.barcode_applied && typeof item.barcode == "string" && typeof item.barcode_qty == "number") {
            allow = true
          } else {
            allow = false
            const appReject = 'Barcode details not set'
            setApproveReject(appReject)
            handleAlertWarning(appReject)
            break
          }
        }
      }

    } else {
      console.log('credit memo check failed')
    }
    console.log('allow before returning', allow)
    return allow
  }

  const handleAlertSuccess = (message) => {
    setAlertSuccess(message)
    setOpenSuccess(true)
    setTimeout(() => {
      setAlertSuccess('')
      setOpenSuccess(false)
    }, 3000)
  }

  const handleAlertWarning = (message) => {
    setAlertWarning(message)
    setOpenWarning(true)
    setTimeout(() => {
      setAlertWarning('')
      setOpenWarning(false)
    }, 3000)
  }

  const closeWarning = () => {
    setOpenWarning(false)
  }

  const closeSuccess = () => {
    setOpenSuccess(false)
  }
  const cancelReturn = async () => {
    let submitPayload = {
      returnOrderId: orderDetails.return_order_id
    }
    const signedToken = generateToken(submitPayload)
    const payload = { "action" : "edit-return" }
    const url = `${legolasApi.url}/api/return/cancel`
    axios.post(url, payload, {
      headers: {
        'Authorization': `Bearer ${signedToken}`,
        'Content-Type': 'application/json'
      }
    }).then(res => res.data).then(data => {
      // console.log("data: ",data);
      if (data.success){
        handleAlertSuccess(data.message)
      } else {
        handleAlertWarning(data.message)
      }
      setTimeout(() => {
        window.location.reload();
      }, 3000)
    })

  }

  
  const saveHandler = async (type = 'normal') => {
    try {
      let submitPayload = {}
      submitPayload = {...updateData}
      let itemsArray = [], allValidated = true
      const updatedItemsPayload = [...itemsPayload]
      const totalLen = updatedItemsPayload.length
      // console.log('totalLen', totalLen)
      let requested = 0, authorized = 0, received = 0, approved = 0
      for (let item in updatedItemsPayload) {
        const elem = updatedItemsPayload[item]
        if (elem.qty_requested == null) {
          elem.errors.qty_requested = true
        } else {
          requested++
        }
        if (elem.qty_authorized == null) {
          elem.errors.qty_authorized = true
        } else {
          authorized++
        }
        if (elem.qty_received == null) {
          elem.errors.qty_received = true
        } else {
          received++
        }
        if (elem.qty_approved == null) {
          elem.errors.qty_approved = true
        } else {
          approved++
        }
      }
      console.log('requested - authrized', requested, authorized)
      console.log('received - approved', received, approved)
      for (let item in updatedItemsPayload) {
        let doPush = false
        if (approved != 0 && approved >= totalLen) {
          doPush = true
        } else if (received != 0 && received >= totalLen) {
          doPush = true
        } else if (authorized != 0 && authorized >= totalLen) {
          doPush = true
        } else if (requested != 0 && requested >= totalLen) {
          doPush = true
        } else {
          doPush = false
        }
        if (doPush) {
          itemsArray.push({ id: item, data: itemsPayload[item]})
        }
      }
      setItemsPayload(updatedItemsPayload)
      if (isArray(itemsArray) && itemsArray.length > 0 && allValidated) {
        let checkforapproved = false, proceedWithSave = true
        itemsArray.forEach(item => {
          const itemData = item.data
          if (itemData.in_approved_state) {
            checkforapproved = true
          }
        })
        if (checkforapproved) {
          proceedWithSave = await verifyBeforeApproving(itemsArray)
        }
        if (proceedWithSave) {
          submitPayload['itemsData'] = itemsArray
          submitPayload['order_id'] = orderDetails.order_id
          submitPayload['entity_id'] = orderDetails.return_order_id
          submitPayload['created_at'] = formatDateAndTime(new Date(orderDetails.return_created_date))
          submitPayload['updated_at'] = formatDateAndTime(new Date())
          submitPayload['increment_id'] = orderDetails.increment_id
          submitPayload['shipping_method'] = defaultCarrier
          submitPayload['is_closed'] = orderDetails.is_closed
          const firstItem = itemsArray[0].data
          const foundReason = returnOptions.returnReason.find(item => item.id == firstItem.reason_id)
          // console.log('foundReason', foundReason)
          submitPayload['return_reason'] = foundReason.title
          // const url = `${legolasApi.url}/api/return/update`
          const url = `${legolasApi.url}/api/return/update/v2`
          axios.post(url, submitPayload, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => res.data).then(data => {
            handleAlertSuccess(data.message)
            if (data.success) {
              if(type == 'normal') {
                backClickHandler()
                
              } else {
                window.location.reload();
              }
            }
            
          })
          
        } 
      } else {
        scrollToTable()
      }
    } catch (err) {
      console.log('Error in updating return', err)
      handleAlertWarning('Error in updating return:' + err)
    }
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }

  const getTotalReturnPrice = () => {
    let price = 0
    itemsPayload.forEach((item) => {
      price += (item.price_incl_tax * item.qty_requested)
    })
    return price
  }

  const refreshPage = ()=>{
    window.location.reload();
 }

  if (isEmpty(fullItems) && isEmpty(itemsPayload)) return null
  return (
    <Box sx={{ width: '100%', maxWidth: '90vw', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar open={openWarning} autoHideDuration={3000} onClose={closeWarning} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeWarning} severity="warning" sx={{ width: '400px', marginTop: '100px' }}>
          {alertWarning}
        </Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeSuccess} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertSuccess}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '2rem',
          fontWeight: 400,
          color: '#000'
        }}}
      >
        <Typography>RMA #{orderDetails.increment_id ? orderDetails.increment_id : null} <span sx={{ textTransform: 'capitalize' }}>({globalConfig.rmaStatus[orderDetails.status].text})</span></Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.white,
          color: '#2b3f7a',
          border: '2px solid #2b3f7a',
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
        }}
        >
          <Button onClick={() => navigate(-1)}>Back</Button>
          {/* <Button onClick={() => backClickHandler()}>Back</Button> */}
          <Button disabled={isCancelled || isApproved} onClick={refreshPage}>Reset</Button>
          {/* <Button disabled={isCancelled || isApproved} onClick={() => cancelReturn()}>Cancel RMA</Button> */}
          <Button disabled={isCancelled || isApproved} onClick={handleOpenCancelConfirmation}>Cancel RMA</Button>
          <Modal
              open={openCancelConfirmation}
              onClose={handleCloseCancelConfirmation}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
               >
              <Box sx={globalStyles.modalContainer}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure want to cancel RMA ?
              </Typography>
                  <Box sx={{
                          display: 'flex', justifyContent: 'end', marginTop: '20px',
                           '& .MuiButton-root': {
                          color: globalStyles.colors.backgroundPrimary,
                          textTransform: 'capitalize'
                            }
                          }}>
                <Button onClick={handleCloseCancelConfirmation}>Cancel</Button>
                <Button onClick={() => cancelReturn()}>OK</Button></Box>
             </Box> 
          </Modal> 
          {/* <Snackbar open={open} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical:'top', horizontal:'center' }} >
            <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
              RMA Cancelled Successfully
            </Alert>
          </Snackbar> */}
          <Button disabled={isCancelled || isApproved} onClick={() => saveHandler('continue')}>Save and Continue Edit</Button>
          <Button disabled={isCancelled || isApproved} sx={{ backgroundColor: '#2b3f7a !important', color: '#fff !important' }} onClick={() => saveHandler('normal')}>Save</Button>
        </Box>
        <Box id='return-info-container'>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12 }>
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Information</Typography>
            </Box>
            <Box id='details-container'>
              <Box sx={darkBox}>
                <Typography>RMA Status</Typography>
                <Typography 
                  sx={{ 
                    backgroundColor: globalConfig.rmaStatus[orderDetails.status].color,
                    color: '#fff',
                    padding: '5px 15px'
                  }}
                >
                  {globalConfig.rmaStatus[orderDetails.status].text}
                </Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Order</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography sx={{ paddingRight: '10px' }}>
                    {orderDetails.order_id ? orderDetails.order_id : null}
                  </Typography>
                  <Typography>
                    ({orderDetails.return_created_date ? formatDateAndTime(new Date(orderDetails.return_created_date)) : null})
                  </Typography>
                </Box>
              </Box>
              <Box sx={darkBox}>
                <Typography>Order Status</Typography>
                <Typography>{orderDetails.order_status ? orderDetails.order_status : null}</Typography>
              </Box>
              {/* <Box sx={lightBox}>
                <Typography>Purchased From</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography sx={{ paddingRight: '10px' }}> <Typography>{orderDetails.purchasedFrom ?
                  <Typography>{orderDetails.purchasedFrom}</Typography> : <Typography>{purchasedFrom === process.env.SENSI_CHANNEL_ID ? "SENSI  Website" : "SHABABUNA  Website"}</Typography>}
                </Typography></Typography>
                  <Typography>{orderDetails.store_name ? orderDetails.store_name : null}</Typography>
                  </Box>
                  </Box> */}
              <Box sx={lightBox}>
                <Typography>Customer Name</Typography>
                <Typography  sx={{wordBreak:"break-word" , marginLeft:"10px"}}>{orderDetails.username ? orderDetails.username : null}</Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>Customer Group</Typography>
                <Typography>General</Typography>
               {/* <Typography>{orderDetails.user_group_code ? orderDetails.user_group_code : null}</Typography>*/}
              </Box>
              <Box sx={lightBox}>
                <Typography>Email</Typography>
                <Typography>{orderDetails.email ? orderDetails.email : orderDetails.guest_user_email}</Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>RMA Manager</Typography>
                <Select 
                  //value={shippingPartnerId} 
                  label='Select Shipping Partner' 
                  onChange={e => updateReturManager(e.target.value)}
                  value={updateData.manager_id}
                  sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000' }}
                  //disabled={true}
                >
                  {
                    adminUsers.map(user => {
                      return (
                        <MenuItem value={user.user_id}>{user.firstname + ' ' + user.lastname}</MenuItem>
                      )
                    })
                  }
                </Select>
              </Box>
              <Box sx={lightBox}>
                <Typography>Return Type</Typography>
                <Select 
                  label='Select Shipping Partner' 
                  //defaultValue={data.return_type}
                  value={updateData.return_type}
                  disabled={isCancelled}
                  sx={{ width: '200px', height: '40px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                  onChange={(e) => updateReturnType(e.target.value)}
                >
                  <MenuItem value="rto">RTO Request</MenuItem>
                  <MenuItem value="customer">Customer Request</MenuItem>
                </Select>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {/*<Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Customer Address</Typography>
            </Box>
            <Box id='customer-address-container'>
              <AddressInfo shipment={shipment}/>
                </Box>*/}  
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '30px 0px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Tracking Information</Typography>
            </Box>
            <Box id='tracking-container'>
              <Card sx={{ width: '100%' }}>
                <CardContent>
                  <Box id='carrier container'>
                    <Typography variant='h6'>Carrier</Typography>
                      <Select 
                        label='Select Shipping Partner' 
                        value={defaultCarrier}
                        disabled={isCancelled}
                        sx={{ width: '80%', height: '45px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', padding: '0px', marginTop: '20px' }}
                        onChange={(e) => setDefaultCarrier(e.target.value)}
                      >
                        <MenuItem value='webkularamex'>Aramex Delivery</MenuItem>
                        <MenuItem value='esnad'>ESNAD Delivery</MenuItem>
                        <MenuItem value='Shababuna'>Shababuna Delivery</MenuItem>
                        <MenuItem value='helix'>Helix Delivery</MenuItem>
                        <MenuItem value='saudipost'>Saudipost Delivery</MenuItem>
                        <MenuItem value='smsa'>SMSA Delivery</MenuItem>
                      </Select>
                  </Box>
                  {/*<Grid container columns={12}>
                    <Grid item xs={5}>
                      <Typography variant='h6'>Carrier</Typography>
                      <Select 
                        label='Select Shipping Partner' 
                        defaultValue={'aramex'}
                        sx={{ width: '80%', height: '45px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', padding: '0px', marginTop: '20px' }}
                      >
                        <MenuItem value='aramex'>Aramex Delivery</MenuItem>
                        <MenuItem value='esnad'>ESNAD Delivery</MenuItem>
                        <MenuItem value='hnak'>HNAK Deliveryt</MenuItem>
                        <MenuItem value='helix'>Helix Delivery</MenuItem>
                        <MenuItem value='saudipost'>Saudipost Delivery</MenuItem>
                        <MenuItem value='smsa'>SMSA Delivery</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography variant='h6'>Tracking Number</Typography>
                      <TextField label="Tracking Number" variant="outlined" sx={{ border: '1px solid #000', marginTop: '20px', padding: '0px', width: '200px' }}/>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant='h6'>Action</Typography>
                      <Button sx={{...globalStyles.reusableButtonLight, marginTop: '20px', border: '1px solid #000 !important', padding: '10px 20px' }}>
                        <Typography>Add</Typography>
                      </Button>
                    </Grid>
                  </Grid>*/}
                </CardContent>
              </Card>
            </Box>
            {/* <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '30px 0px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Upload Shipping Label</Typography>
            </Box>
            <Box>
              <div>
                Insert file upload component here!!
              </div>
            </Box> */}
           <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '30px 0px', paddingBottom: '10px' }}>
  <Typography variant='h6'>Return Product Image</Typography>
</Box>

<Box>
  <Typography variant="h6" sx={{ mb: 2 }}>Return Images</Typography>
  {Array.isArray(returnImages) && returnImages.length > 0 ? (
    <ImagePreview srcList={returnImages} />
  ) : (
    <Box
      sx={{
        width: '100%',
        minHeight: 150,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px dashed #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="body1" color="text.secondary">
        No image found
      </Typography>
    </Box>
  )}
</Box>



          </Grid>
        </Grid>
      </Box>
      <Box id='items-container'>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '20px 0px', paddingBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Typography variant='h6'>
            Items to Return
          </Typography>
          {
            itemsPayload &&
            <Typography variant='h6' sx={{ fontSize: '14px', paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
              {itemsPayload.length} items
            </Typography>
          }
        </Box>
        <Box id='return-form-container'>
          {
          isArray(itemsPayload) && !isEmpty(returnOptions.returnCondition)
          && !isEmpty(returnOptions.returnReason) && !isEmpty(returnOptions.returnResolution) &&
            <TableContainer ref={itemsTableRef}>
              <Table>
                <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                  '& .MuiTableCell-root': {
                    color: '#fff !important',
                    padding: '10px !important',
                    borderRight: '2px solid #fff !important',
                    borderRadius: '0 !important'
                  }
                }}
                >
                  {[...globalConfig.itemReturnTableHeader, ...extraHeaders].map(item => {
                   return (
                      <StyledTableCell align='center'>{item.label}</StyledTableCell>
                    )
                  })}
                </TableHead>
                <TableBody>
                  {itemsPayload.map((item, idx) => {
                    return (
                      <ReturnForm 
                        key={idx} 
                        item={item} 
                        isApproved={isApproved}
                        returnOptions={returnOptions}
                        // itemsPayload={itemsPayload}
                        // data={data}
                        // detailsIdx={idx}
                        updateItemsPayload={updateItemsPayload}
                        cmemoPresent={cmemoPresent}
                        setBarcodeInfo={setBarcodeInfo}
                      />
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          }
        </Box>
      </Box>
      <Box id='price-container' sx={{ marginBottom: '10%' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '20px 0px', paddingBottom: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          <Typography variant='h6'>
            Total Price to Return:
          </Typography>
        </Box>
        <Typography variant='h6' sx={{ fontSize: '20px', fontWeight: 'bold' }}>
            SAR {totalPriceToReturn.toFixed(4)}
          </Typography>
      </Box>
    </Box>
  )
}

export default EditReturn